import { useMemo } from "react";

import { useGetUserMeAccountsQuery } from "fond/api";
import { UserRole } from "fond/types";

/**
 * Returns a Map from account ID to the current user's role in that account.
 */
export const useAccountRoles = (): Map<string, UserRole> => {
  const { data: meAccounts } = useGetUserMeAccountsQuery();

  return useMemo(() => {
    const map = new Map<string, UserRole>();
    meAccounts?.forEach((allocation) => map.set(allocation.Account.ID, allocation.Role));
    return map;
  }, [meAccounts]);
};
